module.exports = __webpack_public_path__ + "assets/img/mecha-btn-223b6192.png";